export default {
  getService: state => state.service,
  getServices: state => state.services,
  statistics: state => state.statistics,
  showArchived: state => state.showArchived,
}
